import _ from 'underscore';
import jQuery from 'jquery';
import Backbone from 'backbone';
import Localizer from 'localizer';
import UrlParser from 'utils/parsers/UrlParser';
import moment from 'moment';
import { atpApi } from 'config/axios';

var urlParser = new UrlParser();
var util = function() {};

export const TrainingVersion = {
    HeartRate: 'HeartRate',
    Power: 'Power'
};

// We need to sort cycling plans by unbound gravel types. We have a list of these plankeys predefined in web-data
// TODO - Unbound Gravel, remove later
util.prototype.isConsideredUnbound = function(planKey) {
    const unboundIds = [
        'cyc_ccb06cda-6fd1-4bb3-93ec-c20893c72ab0',
        'cyc_4146f592-d1db-4e36-ba9b-30a70b447b02',
        'cyc_f44620b4-f48e-4308-a8d4-2d7651e18adc',
        'cyc_2173c020-0249-4bb0-8473-df3ea9a04689',
        'cyc_1e7d8396-e4d3-44ab-97dd-cac575cc2d01',
        'cyc_f47688ee-4fe7-4a7e-97d4-f752cddb0fee',
        'cyc_84a42b47-6b10-42f1-b96a-b8456842454a',
        'cyc_30723a43-5160-4847-8e73-55bcd8ef61d2',
        'cyc_2810e7bf-dcd3-40c5-8d50-0135a864b4bb',
        'cyc_e0df95c4-3b7b-48ee-bdcd-438441ed2b95'
    ];

    if (unboundIds) {
        for (let i = 0; i < unboundIds.length; i++) {
            if (unboundIds[i] === planKey) {
                return true;
            }
        }
        return false;
    }
};

export const isConsideredUnbound = (planKey) => {
    const unboundIds = [
        'cyc_ccb06cda-6fd1-4bb3-93ec-c20893c72ab0',
        'cyc_4146f592-d1db-4e36-ba9b-30a70b447b02',
        'cyc_f44620b4-f48e-4308-a8d4-2d7651e18adc',
        'cyc_2173c020-0249-4bb0-8473-df3ea9a04689',
        'cyc_1e7d8396-e4d3-44ab-97dd-cac575cc2d01',
        'cyc_f47688ee-4fe7-4a7e-97d4-f752cddb0fee',
        'cyc_84a42b47-6b10-42f1-b96a-b8456842454a',
        'cyc_30723a43-5160-4847-8e73-55bcd8ef61d2',
        'cyc_2810e7bf-dcd3-40c5-8d50-0135a864b4bb',
        'cyc_e0df95c4-3b7b-48ee-bdcd-438441ed2b95'
    ];

    return unboundIds.includes(planKey);
};

util.prototype.updateUrlHistory = function(path, newValues) {
    var newQueryStrings,
        existingQueryStrings = urlParser.parseQueryString(window.location.search);

    path = path || 'training-plan';

    if (existingQueryStrings) {
        //extend existing and new query values
        newQueryStrings = jQuery.extend({}, existingQueryStrings, newValues);
    } else if (newValues && !_.isEmpty(newValues)) {
        newQueryStrings = newValues;
    }

    Backbone.history.navigate(path + urlParser.convertObjectToQueryString(newQueryStrings), {
        trigger: false,
        replace: true
    });
};

util.prototype.updateUrlHistroyToRemoveQueryStrings = function(path) {
    path = path || '/training-plan';
    Backbone.history.navigate(path, { trigger: false, replace: true });
};

util.prototype.getQueryString = function() {
    ///Returns a object of query strings
    return urlParser.parseQueryString(window.location.search);
};

util.prototype.getActiveTypeFromQueryString = function(queryString, activityFilterOptions) {
    if (queryString && queryString.type) {
        if (activityFilterOptions && activityFilterOptions[queryString.type]) {
            return { type: queryString.type };
        }
    }

    return {};
};

util.prototype.Images = {
    running: 'full-potential-logo-120.png',
    triathlon: 'triathlon-performance-logo-120.png',
    cycling: null,
    swimming: 'TBD.png',
    unbound: 'Unbound_Gravel_ALT_Garmin_Craft_RGB.png'
};

util.prototype.FilterOptions = {
    'plan-filter-activity': {
        Activity: {
            value: 'training_plans_all_plan_types',
            hide: false
        },
        Running: {
            value: 'activity_type_running',
            hide: false
        },
        Cycling: {
            value: 'activity_type_cycling',
            hide: false
        },
        Triathlon: {
            value: 'activity_type_triathlon',
            hide: false
        },
        Unbound: {
            value: 'activity_type_unbound',
            hide: false
        }
    },
    'plan-filter-distance': {
        Distance: {
            value: 'training_plans_all_distance',
            hide: false
        },
        '5k': {
            value: 'training_plans_filter_5k',
            hide: true
        },
        '10k': {
            value: 'training_plans_filter_10K',
            hide: true
        },
        HalfMarathon: {
            value: 'training_plans_filter_half_marathon',
            hide: true
        },
        Marathon: {
            value: 'training_plans_filter_marathon',
            hide: true
        },
        Other: {
            value: 'training_plans_filter_other',
            hide: true
        },
        Sprint: {
            value: 'training_plans_filter_sprint',
            hide: true
        },
        Olympic: {
            value: 'training_plans_filter_olympic',
            hide: true
        },
        FullCentury: {
            value: 'training_plans_filter_century',
            hide: true
        },
        HalfCentury: {
            value: 'training_plans_filter_half_century',
            hide: true
        },
        GranFondo: {
            value: 'training_plans_filter_gran_fondo',
            hide: true
        },
        TimeTrial: {
            value: 'training_plans_filter_time_trial',
            hide: true
        },
        Crit: {
            value: 'training_plans_filter_crit',
            hide: true
        },
        MountainBiking: {
            value: 'training_plans_filter_mtb',
            hide: true
        }
    },
    'plan-filter-level': {
        Level: {
            value: 'training_plans_all_levels',
            hide: false
        },
        'Level 1': {
            value: 'training_plans_filter_level_1',
            hide: true
        },
        'Level 2': {
            value: 'training_plans_filter_level_2',
            hide: true
        },
        'Level 3': {
            value: 'training_plans_filter_level_3',
            hide: true
        }
    }
};

util.prototype.getAdaptiveTrainingPlanName = function(planName, Localizer) {
    return planName + ' ' + Localizer.localize('training_plan_plan_label');
};

util.prototype.getATPNameFromPlanTypes = function(id, planTypes) {
    for (var i = 0; i < planTypes.length; i++) {
        if (planTypes[i] && planTypes[i].workoutPlanTypeId === id) {
            return planTypes[i].name + ' ' + Localizer.localize('training_plan_plan_label');
        }
    }
    //default: Adaptive Training Plan
    return Localizer.localize('atp_training_plan_label');
};

util.prototype.sendCoachReaction = function(athletePlanId, actionId, actionOptionId, success, error) {
    var reactionDate = new moment(new Date()).format('YYYY-MM-DDThh:mm:ss'),
        reaction = {
            athletePlanId: athletePlanId,
            reaction: {
                actionId: actionId,
                actionOptionId: actionOptionId,
                reactionDate: reactionDate
            }
        };

    let options = {
        headers: { 'content-type': 'application/json' }
    };

    return atpApi
        .post('/atp/athlete/react', JSON.stringify(reaction), options)
        .then(() => {
            if (success) {
                success();
            }
            return this;
        })
        .catch(() => {
            if (error) {
                error();
            }
            return this;
        });
};

util.prototype.findActionByOptionId = function(actionOptionId, action) {
    var actionOption = null;
    if (actionOptionId !== null && action) {
        actionOption = _.find(action.options, function(option) {
            return option.actionOptionId === actionOptionId;
        });
    }
    return actionOption;
};

export default util;
